<div class="spinner mx-auto my-auto" [ngStyle]="{'width': size + 'rem', 'height': size + 'rem'}">
  <div class="double-bounce1" [class.black]="black" [class.white]="white"></div>
  <div class="double-bounce2" [class.black]="black" [class.white]="white"></div>
</div>
